<!--
  --
  -- 予約カードコンポーネント
  --
  -->
<template>
  <v-card>
    <!-- ステーション名 -->
    <v-card-subtitle class="text--primary">
      {{book.stationName}}
    </v-card-subtitle>

    <v-card-text>
      <v-row dense>
        <!-- 日程 -->
        <v-col cols="12" class="d-flex align-center">
          <c-time-sheet :color="timeColor" class="flex-grow-1" :time="book.period.begin"/>
          <v-icon class="flex-shrink-0">arrow_right</v-icon>
          <c-time-sheet :color="timeColor" class="flex-grow-1" :time="book.period.end"/>
        </v-col>

        <!-- 車両情報 -->
        <v-col cols="12">
          <div>
            <small>{{book.car.typeName}} / {{book.car.className}}クラス</small>
          </div>
          <div class="text--primary">
            <small>{{book.car.maker}} </small>
            <span>{{book.car.name}}</span>
            <span v-if="book.car.attributes.keykey === 1" v-bind:class="color_class">24h</span>
          </div>
        </v-col>

        <!-- 料金 -->
        <v-col cols="12">
          <v-divider/>

          <div class="text--primary text-right mt-2">
            <span>{{book.charge.total | comma}}</span>
            <small>円</small>
            <span v-if="book.period.over">（延長 {{book.charge.overCharge | comma}} <small>円</small>）</span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <a :href="book.VKeyURL" class="vkey_link" target="_blank" v-if="book.VKeyURL">
        <v-btn
          text outlined
        >
          VKey<span class="material-icons">file_download</span>
        </v-btn>
      </a>
      <v-btn
        text outlined
        v-if="book.extension"
        @click="onExtension(book.reserveID)"
      >
        延長
      </v-btn>
      <v-btn
        text outlined
        :disabled="!book.cancelable"
        @click="onCancel(book.reserveID)"
      >
        キャンセル
      </v-btn>
      <!-- v-btn
        text outlined
        :disabled="!book.editable"
        @click="onEdit(book.reserveID)"
      >
        変更
      </v-btn -->
    </v-card-actions>
  </v-card>
</template>

<style>
.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
.vkey_link {
  text-decoration: none;
  margin-right: 4px;
}
</style>

<script>
import CTimeSheet from '@/components/CTimeSheet'
import store from '@/store'
import * as http from '@/libs/http'
import * as api from '@/api'

export default {
  name: 'CBookCard',
  components: {
    CTimeSheet
  },
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  computed: {
    timeColor () {
      return this.$vuetify.theme.isDark ? 'rgba(0,0,0,.5)' : 'rgba(0,0,0,.05)'
    },

    color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'AttributesIcon Attributes_Dark primary ml-4'
      } else {
        ClassName = 'AttributesIcon Attributes_Bright primary ml-4'
      }
      return ClassName
    }
  },
  methods: {
    /**
     * 延長ボタン
     */
    async onExtension (rid) {
      await this.dispatch('book/load', this.book)
      this.goTo({ name: 'book/extension' })
    },

    /**
     * 変更ボタン
     */
    async onEdit (rid) {
      await this.dispatch('book/load', this.book)
      this.goTo({ name: 'book/period', params: { stid: this.book.stationID, rid: rid } })
    },

    /**
     * キャンセルボタン
     */
    async onCancel (rid) {
      if (confirm(this.book.period.begin + ' ～ ' + this.book.period.end + '\n' + this.book.car.maker + this.book.car.name + '\n\n上記予約をキャンセルします')) {
        // ログイン中のユーザID を取得する
        const userID = store.getters['user/id']
        // console.log(userID)
        // console.log(rid)

        // キャンセルする
        const resp = await api.cancelReserve(userID, rid)
        if (resp.status !== http.OK) {
          alert('予約のキャンセルに失敗しました')
          return
        } else {
          alert('キャンセルしました')
          this.$router.go({ path: '/my/books', force: true })
        }
      } else {
        return
      }
      const Flg = 0
      return Flg
    }
  }
}
</script>
